import React from "react";
import PhoneInput from "react-phone-input-2";
import ErrorMessage from "../../../../common/ErrorMessage";
import GoogleInput from "../../../../common/GoogleInput";
import { FormError } from "../../../../common/Input";
import wave from "../../../../../assets/images_td/icons/wave.png";
import visa from "../../../../../assets/images_td/icons/visa.png";
import money_check from "../../../../../assets/images_td/icons/mch.png";

const AdresseLivraison = ({
  register,
  errors,
  handleChangePhone,
  phone,
  onChangeAdresse,
  adresse,
  vendeur,
}) => {
  return (
    <div className="container form-register-tabs-component mt-4">
      <h1 className="custom_validate_cart_step__title">Vos informations</h1>

      <div className="infos_livraison_container pt-4">
        <div className="row">
          <div className="col-12 mb-3 d-flex gap-3">
            <div className="input_wrapper_v2">
              <label className="field-label">
                Prénom <span className="required-star">*</span>
              </label>
              <input
                className="form-control-v2"
                type="text"
                {...register("prenom_client")}
                placeholder="Fatou"
              />
              <ErrorMessage
                message={
                  errors?.prenom_client && errors?.prenom_client?.message
                }
              />
            </div>

            <div className="input_wrapper_v2">
              <label className="field-label">
                Nom <span className="required-star">*</span>
              </label>
              <input
                className="form-control-v2"
                type="text"
                {...register("nom_client")}
                placeholder="Ba"
              />
              <ErrorMessage
                message={errors?.nom_client && errors?.nom_client?.message}
              />
            </div>
          </div>

          <div className="col-md-7 mb-3">
            <div className="input_wrapper_v2">
              <label className="field-label">
                Téléphone <span className="required-star">*</span>
              </label>
              <PhoneInput
                inputProps={{ name: "phone" }}
                defaultMask={".. ... .. .."}
                country="sn"
                value={phone}
                enableSearch={true}
                onChange={(phone, country) => handleChangePhone(phone, country)}
                inputClass="form-control-v2 form-control-v2-tel"
                enableAreaCodes={true}
                prefix="+"
                countryCodeEditable={false}
                placeholder="+221 77 000 00 00"
              />
              <ErrorMessage
                message={errors?.telephone && errors?.telephone?.message}
              />
            </div>
          </div>

          <div className="col-md-7 mb-3">
            <div className="input_wrapper_v2">
              <label className="field-label">Email (optionnel)</label>
              <input
                className="form-control-v2"
                type="text"
                {...register("email_client")}
                placeholder="votre@email.com"
              />
              <ErrorMessage
                message={
                  errors?.email_client && errors?.email_client?.message
                }
              />
            </div>
          </div>

          <div className="col-md-7 mb-3">
            <div className="input_wrapper_v2">
              <label className="field-label">
                Adresse de livraison <span className="required-star">*</span>
              </label>
              <GoogleInput
                className="form-control-v2 form-control-v2-address"
                value={adresse}
                onChange={onChangeAdresse}
                placeholder="Quartier, rue, ville..."
              />
              <ErrorMessage
                message={errors?.adresse && errors?.adresse?.message}
              />
            </div>
          </div>

          <div className="col-md-7 mb-3">
            <div className="input_wrapper_v2">
              <label className="field-label">
                Informations complémentaires
              </label>
              <textarea
                id="informations_complementaires"
                className="form-control-v2 form-control-v2-textarea"
                placeholder="Nº appartement, étage, point de repère..."
                cols={30}
                rows={4}
                {...register("informations_complementaires")}
              ></textarea>
              <FormError
                error={errors?.informations_complementaires?.message}
              />
            </div>
          </div>

          <div className="col-md-7 mb-3">
            <div className="input_wrapper_v2">
              <label className="field-label">
                Moyen de paiement <span className="required-star">*</span>
              </label>

              <div className="payment-options-list mt-2">
                {vendeur?.wave_is_set && (
                  <label className="payment-option-row">
                    <input
                      type="radio"
                      className="payment-option-radio"
                      {...register("mode_de_paiement")}
                      value="WAVE"
                    />
                    <span className="payment-option-icon payment-option-icon--wave">
                      <img loading="lazy" src={wave} alt="Wave" />
                    </span>
                    <span className="payment-option-label">Wave Money</span>
                  </label>
                )}

                {vendeur?.stripe_is_set && (
                  <label className="payment-option-row">
                    <input
                      type="radio"
                      className="payment-option-radio"
                      {...register("mode_de_paiement")}
                      value="STRIPE"
                    />
                    <span className="payment-option-icon payment-option-icon--stripe">
                      <img loading="lazy" src={visa} alt="Carte bancaire" />
                    </span>
                    <span className="payment-option-label">Carte bancaire</span>
                  </label>
                )}

                <label className="payment-option-row">
                  <input
                    type="radio"
                    className="payment-option-radio"
                    {...register("mode_de_paiement")}
                    value="CASH"
                    defaultChecked
                  />
                  <span className="payment-option-icon payment-option-icon--cash">
                    <img loading="lazy" src={money_check} alt="Paiement à la livraison" />
                  </span>
                  <span className="payment-option-label">
                    Paiement à la livraison
                  </span>
                </label>
              </div>

              <ErrorMessage
                message={
                  errors?.mode_de_paiement && errors?.mode_de_paiement?.message
                }
              />
            </div>
          </div>

          <div className="col-md-7 mb-3">
            <div className="payment-info-banner">
              <span className="payment-info-icon" aria-hidden="true">ℹ️</span>
              <span>
                Après validation, l&apos;équipe {vendeur?.nom_boutique || "de la boutique"}{" "}
                vous contactera pour confirmer votre commande et organiser la
                livraison ou le retrait.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdresseLivraison;